module.exports = __webpack_public_path__ + "img/zhangjiagang-logo.8dc49c06.png";